import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.images.item');
import { OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare var monaco: any;

@Component({
    selector: 'wiz-page-admin-images-item',
template: templateSource || '',
    styles: [`

/* file: /opt/season-cloud-manager/project/main/build/src/app/page.admin.images.item/view.scss */
::ng-deep .monaco-editor {
  height: 100% !important;
}

::ng-deep .agent-markdown {
  color: #24292f;
  font-size: 13px;
  line-height: 1.55;
  overflow-wrap: anywhere;
}

::ng-deep .agent-markdown :where(h1, h2, h3, h4, h5, h6) {
  margin: 0.9em 0 0.45em;
  font-weight: 600;
  line-height: 1.25;
}

::ng-deep .agent-markdown :where(h1, h2) {
  border-bottom: 1px solid #d8dee4;
  padding-bottom: 0.3em;
}

::ng-deep .agent-markdown h1 {
  font-size: 1.45em;
}

::ng-deep .agent-markdown h2 {
  font-size: 1.25em;
}

::ng-deep .agent-markdown h3 {
  font-size: 1.1em;
}

::ng-deep .agent-markdown p {
  margin: 0 0 0.75em;
}

::ng-deep .agent-markdown :where(ul, ol) {
  margin: 0 0 0.75em;
  padding-left: 1.4em;
}

::ng-deep .agent-markdown ul {
  list-style: disc;
}

::ng-deep .agent-markdown ol {
  list-style: decimal;
}

::ng-deep .agent-markdown li + li {
  margin-top: 0.25em;
}

::ng-deep .agent-markdown blockquote {
  margin: 0 0 0.75em;
  border-left: 0.25em solid #d0d7de;
  color: #57606a;
  padding-left: 1em;
}

::ng-deep .agent-markdown code {
  border-radius: 6px;
  background: #f6f8fa;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  font-size: 0.92em;
  padding: 0.12em 0.35em;
}

::ng-deep .agent-markdown pre {
  margin: 0 0 0.75em;
  overflow: auto;
  border-radius: 6px;
  background: #f6f8fa;
  padding: 12px;
}

::ng-deep .agent-markdown pre code {
  display: block;
  background: transparent;
  padding: 0;
  white-space: pre;
}

::ng-deep .agent-markdown a {
  color: #0969da;
  text-decoration: underline;
}

::ng-deep .agent-markdown > :last-child {
  margin-bottom: 0;
}`],
})
export class PageAdminImagesItemComponent implements OnInit, OnDestroy {
    @ViewChild('monacoContainer') monacoContainer: ElementRef;
    @ViewChild('logContainer') logContainer: ElementRef;

    public id: string = '';
    public data: any = {};
    public loading: boolean = false;
    public updating: boolean = false;
    public building: boolean = false;
    public pushing: boolean = false;

    // File tree
    public fileTree: any[] = [];
    public currentPath: string = '';
    public selectedFile: string = '';
    public selectedFileContent: string = '';
    public expandedFolders: Set<string> = new Set();

    // Monaco editor
    private editor: any = null;

    // Modals
    public showSettingsModal: boolean = false;
    public showNewFileModal: boolean = false;
    public showNewFolderModal: boolean = false;
    public showRenameModal: boolean = false;
    public newItemName: string = '';
    public newItemPath: string = '';
    public renameOldPath: string = '';
    public renameNewName: string = '';
    public harborProjects: any[] = [];
    public buildLog: string = '';
    public buildLogTitle: string = 'Build / Push Log';
    public showLogModal: boolean = false;
    public editorLoading: boolean = false;
    public editorReady: boolean = false;
    public editorError: string = '';

    // Context menu
    public showContextMenu: boolean = false;
    public contextMenuX: number = 0;
    public contextMenuY: number = 0;
    public contextMenuItem: any = null;

    // Git
    public gitStatus: any = { initialized: false, status: '', branch: '', remote: '' };
    public gitLog: any[] = [];
    public gitCommitMessage: string = '';
    public showGitPanel: boolean = false;
    public gitLoading: boolean = false;
    public activeToolPanel: string = '';
    public toolPanelWidth: number = 384;
    private toolPanelResizing: boolean = false;
    private lastToolPanelRender: number = 0;

    // Codex agent
    public agentSessions: any[] = [];
    public selectedAgentSession: any = null;
    public agentPrompt: string = '';
    public agentView: string = 'history';
    public agentLoading: boolean = false;
    public expandedAgentPromptIndex: number = -1;
    private agentPollTimer: any = null;
    private readonly agentTurnSeparator: string = '<<<SEASON_AGENT_TURN>>>';

    constructor(@Inject( Service) public service: Service) {
        this.id = WizRoute.segment.id;
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.role("admin", "/");
        await this.loadHarborProjects();
        await this.load();
        this.loadMonacoScript();
    }

    public ngOnDestroy() {
        if (this.editor) {
            this.editor.dispose();
            this.editor = null;
        }
        this.stopAgentPolling();
        this.stopToolPanelResize();
        document.removeEventListener('click', this.hideContextMenu);
    }

    private hideContextMenu = async () => {
        this.showContextMenu = false;
        await this.service.render();
    }

    public async load() {
        this.loading = true;
        await this.service.render();
        const { code, data } = await wiz.call("get", { id: this.id });
        if (code !== 200) {
            this.service.href("/admin/images");
            return;
        }
        this.data = data;
        await this.loadFileTree();
        this.loading = false;
        await this.service.render();
    }

    public async loadHarborProjects() {
        try {
            const { code, data } = await wiz.call("harbor_projects");
            if (code === 200) {
                this.harborProjects = data;
                await this.service.render();
            }
        } catch (e) { }
    }

    // ──────────── File tree ────────────

    public async loadFileTree(path: string = '') {
        const { code, data } = await wiz.call("file_tree", { id: this.id, path });
        if (code === 200) {
            if (path === '') {
                this.fileTree = data;
            } else {
                this.setSubTree(this.fileTree, path, data);
            }
        }
        await this.service.render();
    }

    private setSubTree(tree: any[], path: string, children: any[]) {
        for (let item of tree) {
            if (item.path === path) {
                item.children = children;
                return true;
            }
            if (item.children) {
                if (this.setSubTree(item.children, path, children)) return true;
            }
        }
        return false;
    }

    public async toggleFolder(item: any) {
        if (this.expandedFolders.has(item.path)) {
            this.expandedFolders.delete(item.path);
            item.children = null;
        } else {
            this.expandedFolders.add(item.path);
            await this.loadFileTree(item.path);
        }
        await this.service.render();
    }

    public async selectFile(item: any) {
        if (item.type === 'folder') {
            await this.toggleFolder(item);
            return;
        }
        this.selectedFile = item.path;
        await this.service.render();
        const { code, data } = await wiz.call("read_file", { id: this.id, path: item.path });
        if (code === 200) {
            this.selectedFileContent = data.content;
            this.updateMonacoContent();
        } else {
            this.selectedFileContent = '';
            this.updateMonacoContent();
            await this.service.modal.error('Cannot read file (binary?)');
        }
        await this.service.render();
    }

    public getFileIcon(item: any) {
        if (item.type === 'folder') return '📁';
        const ext = item.name.split('.').pop()?.toLowerCase();
        const map: any = { 'py': '🐍', 'js': '📜', 'ts': '📜', 'sh': '⚙️', 'json': '📋', 'yml': '📋', 'yaml': '📋', 'md': '📝', 'txt': '📄', 'html': '🌐', 'css': '🎨', 'scss': '🎨' };
        return map[ext] || '📄';
    }

    public getIndent(path: string) {
        return (path.split('/').length - 1) * 16;
    }

    // ──────────── Context menu ────────────

    public async onRightClick(event: MouseEvent, item: any) {
        event.preventDefault();
        event.stopPropagation();
        this.showContextMenu = true;
        this.contextMenuX = event.clientX;
        this.contextMenuY = event.clientY;
        this.contextMenuItem = item;
        await this.service.render();
        setTimeout(() => document.addEventListener('click', this.hideContextMenu, { once: true }), 0);
    }

    public async onTreeRightClick(event: MouseEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.showContextMenu = true;
        this.contextMenuX = event.clientX;
        this.contextMenuY = event.clientY;
        this.contextMenuItem = null;
        await this.service.render();
        setTimeout(() => document.addEventListener('click', this.hideContextMenu, { once: true }), 0);
    }

    // ──────────── File operations ────────────

    public async openNewFile(basePath: string = '') {
        this.newItemPath = basePath;
        this.newItemName = '';
        this.showNewFileModal = true;
        this.showContextMenu = false;
        await this.service.render();
    }

    public async openNewFolder(basePath: string = '') {
        this.newItemPath = basePath;
        this.newItemName = '';
        this.showNewFolderModal = true;
        this.showContextMenu = false;
        await this.service.render();
    }

    public async createNewFile() {
        if (!this.newItemName) return;
        const path = this.newItemPath ? `${this.newItemPath}/${this.newItemName}` : this.newItemName;
        await wiz.call("create_file", { id: this.id, path });
        this.showNewFileModal = false;
        await this.refreshTree();
    }

    public async createNewFolder() {
        if (!this.newItemName) return;
        const path = this.newItemPath ? `${this.newItemPath}/${this.newItemName}` : this.newItemName;
        await wiz.call("create_folder", { id: this.id, path });
        this.showNewFolderModal = false;
        await this.refreshTree();
    }

    public async openRenameModal(item: any) {
        this.renameOldPath = item.path;
        this.renameNewName = item.name;
        this.showRenameModal = true;
        this.showContextMenu = false;
        await this.service.render();
    }

    public async renameItem() {
        if (!this.renameNewName) return;
        const parts = this.renameOldPath.split('/');
        parts[parts.length - 1] = this.renameNewName;
        const new_path = parts.join('/');
        await wiz.call("rename_file", { id: this.id, old_path: this.renameOldPath, new_path });
        this.showRenameModal = false;
        if (this.selectedFile === this.renameOldPath) {
            this.selectedFile = new_path;
        }
        await this.refreshTree();
    }

    public async deleteItem(item: any) {
        let res = await this.service.modal.show({
            title: 'Delete',
            message: `Delete "${item.name}"?`,
            status: 'error',
            actionBtn: 'error',
            action: 'Delete',
            cancel: 'Cancel'
        });
        this.showContextMenu = false;
        if (res) {
            await wiz.call("delete_file", { id: this.id, path: item.path });
            if (this.selectedFile === item.path) {
                this.selectedFile = '';
                this.selectedFileContent = '';
                if (this.editor) this.editor.setValue('');
            }
            await this.refreshTree();
        } else {
            await this.service.render();
        }
    }

    public async downloadFile(item: any) {
        this.showContextMenu = false;
        await this.service.render();
        if (item.type === 'folder') {
            window.open(`/wiz/api/page.admin.images.item/download_folder?id=${this.id}&path=${encodeURIComponent(item.path)}`, '_blank');
        } else {
            window.open(`/wiz/api/page.admin.images.item/download_file?id=${this.id}&path=${encodeURIComponent(item.path)}`, '_blank');
        }
    }

    public async downloadWorkspace() {
        window.open(`/wiz/api/page.admin.images.item/download_folder?id=${this.id}&path=`, '_blank');
    }

    public async uploadFiles(basePath: string = '') {
        this.showContextMenu = false;
        await this.service.render();
        const input = document.createElement('input');
        input.type = 'file';
        input.multiple = true;
        input.onchange = async (e: any) => {
            const files = e.target.files;
            if (!files.length) return;
            const formData = new FormData();
            for (let f of files) formData.append('files', f);
            formData.append('id', this.id);
            formData.append('path', basePath);

            try {
                const resp = await fetch(`/wiz/api/page.admin.images.item/upload_file`, {
                    method: 'POST',
                    body: formData
                });
                if (resp.ok) await this.refreshTree();
            } catch (e) { }
        };
        input.click();
    }

    public async uploadFolder(basePath: string = '') {
        this.showContextMenu = false;
        await this.service.render();
        const input = document.createElement('input');
        input.type = 'file';
        (input as any).webkitdirectory = true;
        input.onchange = async (e: any) => {
            const files = e.target.files;
            if (!files.length) return;
            const formData = new FormData();
            for (let f of files) {
                formData.append('files', f, f.webkitRelativePath);
            }
            formData.append('id', this.id);
            formData.append('path', basePath);

            try {
                const resp = await fetch(`/wiz/api/page.admin.images.item/upload_folder`, {
                    method: 'POST',
                    body: formData
                });
                if (resp.ok) await this.refreshTree();
            } catch (e) { }
        };
        input.click();
    }

    public async refreshTree() {
        this.expandedFolders.clear();
        await this.loadFileTree();
    }

    // ──────────── Monaco editor ────────────

    private loadMonacoScript() {
        if ((window as any).monaco) {
            this.initMonaco();
            return;
        }
        this.editorLoading = true;
        this.editorError = '';
        this.service.render();
        const script = document.createElement('script');
        script.src = '/lib/vs/loader.js';
        script.onload = () => {
            (window as any).require.config({
                paths: { vs: '/lib/vs' }
            });
            (window as any).require(['vs/editor/editor.main'], () => {
                this.initMonaco();
            }, async (err: any) => {
                this.editorLoading = false;
                this.editorError = err?.message || 'Editor failed to load';
                await this.service.render();
            });
        };
        script.onerror = async () => {
            this.editorLoading = false;
            this.editorError = 'Editor failed to load';
            await this.service.render();
        };
        document.head.appendChild(script);
    }

    private async initMonaco() {
        if (!this.monacoContainer?.nativeElement) {
            setTimeout(() => this.initMonaco(), 100);
            return;
        }
        if (this.editor) return;

        this.editorLoading = false;
        this.editorError = '';
        try {
            this.editor = monaco.editor.create(this.monacoContainer.nativeElement, {
                value: this.selectedFileContent || '',
                language: this.getLanguage(this.selectedFile),
                theme: 'vs-dark',
                automaticLayout: true,
                minimap: { enabled: true },
                fontSize: 13,
                tabSize: 4,
                wordWrap: 'on',
                lineNumbers: 'on',
                scrollBeyondLastLine: false,
                renderLineHighlight: 'line'
            });
            this.editorReady = true;
        } catch (e: any) {
            this.editorReady = false;
            this.editorError = e?.message || 'Editor failed to initialize';
            await this.service.render();
            return;
        }

        // Ctrl+S to save
        this.editor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyS, () => {
            this.saveFile();
        });
        await this.service.render();
    }

    private updateMonacoContent() {
        if (this.editor) {
            const model = this.editor.getModel();
            if (model) {
                model.setValue(this.selectedFileContent || '');
                monaco.editor.setModelLanguage(model, this.getLanguage(this.selectedFile));
            }
        }
    }

    private getLanguage(filepath: string) {
        if (!filepath) return 'plaintext';
        const ext = filepath.split('.').pop()?.toLowerCase();
        const map: any = {
            'py': 'python', 'js': 'javascript', 'ts': 'typescript', 'json': 'json',
            'html': 'html', 'css': 'css', 'scss': 'scss', 'yaml': 'yaml', 'yml': 'yaml',
            'md': 'markdown', 'sh': 'shell', 'bash': 'shell', 'xml': 'xml',
            'dockerfile': 'dockerfile', 'sql': 'sql', 'pug': 'pug', 'txt': 'plaintext'
        };
        const name = filepath.split('/').pop()?.toLowerCase() || '';
        if (name === 'dockerfile') return 'dockerfile';
        return map[ext] || 'plaintext';
    }

    public async saveFile() {
        if (!this.selectedFile || !this.editor) return;
        const content = this.editor.getValue();
        const { code } = await wiz.call("write_file", { id: this.id, path: this.selectedFile, content });
        if (code === 200) {
            await this.service.modal.success(`${this.selectedFile} saved`);
        }
    }

    // ──────────── Settings ────────────

    public toolTabClass(name: string) {
        if (this.activeToolPanel === name) {
            return 'bg-white text-gray-950 shadow-sm';
        }
        return 'text-gray-600 hover:bg-white/70 hover:text-gray-950';
    }

    public async openSettings() {
        this.activeToolPanel = this.activeToolPanel === 'settings' ? '' : 'settings';
        this.showGitPanel = false;
        this.stopAgentPolling();
        this.showSettingsModal = false;
        await this.service.render();
    }

    public async closeSettings() {
        this.showSettingsModal = false;
        if (this.activeToolPanel === 'settings') this.activeToolPanel = '';
        await this.service.render();
    }

    public startToolPanelResize(event: MouseEvent) {
        event.preventDefault();
        this.toolPanelResizing = true;
        document.body.classList.add('select-none');
        document.addEventListener('mousemove', this.resizeToolPanel);
        document.addEventListener('mouseup', this.stopToolPanelResize);
    }

    private resizeToolPanel = async (event: MouseEvent) => {
        if (!this.toolPanelResizing) return;
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 1200;
        const maxWidth = Math.max(320, Math.min(760, viewportWidth - 520));
        const nextWidth = Math.max(320, Math.min(maxWidth, viewportWidth - event.clientX));
        this.toolPanelWidth = Math.round(nextWidth);

        const now = Date.now();
        if (now - this.lastToolPanelRender > 32) {
            this.lastToolPanelRender = now;
            await this.service.render();
        }
    }

    private stopToolPanelResize = async () => {
        if (!this.toolPanelResizing) return;
        this.toolPanelResizing = false;
        document.body.classList.remove('select-none');
        document.removeEventListener('mousemove', this.resizeToolPanel);
        document.removeEventListener('mouseup', this.stopToolPanelResize);
        await this.service.render();
    }

    public async closeNewFileModal() {
        this.showNewFileModal = false;
        await this.service.render();
    }

    public async closeNewFolderModal() {
        this.showNewFolderModal = false;
        await this.service.render();
    }

    public async closeRenameModal() {
        this.showRenameModal = false;
        await this.service.render();
    }

    public async saveSettings() {
        this.updating = true;
        await this.service.render();
        const pd = JSON.stringify(this.data);
        const { code, data } = await wiz.call("update", { data: pd });
        if (code === 200) {
            this.data = data;
        }
        this.showSettingsModal = false;
        if (this.activeToolPanel === 'settings') this.activeToolPanel = '';
        this.updating = false;
        await this.service.render();
    }

    // ──────────── Docker build & push (SSE streaming) ────────────

    private abortController: AbortController | null = null;

    private async runSSE(url: string, title: string): Promise<boolean> {
        this.buildLogTitle = `${title} Log`;
        this.buildLog = '';
        this.showLogModal = true;
        await this.service.render();

        this.abortController = new AbortController();
        let success = false;

        try {
            const response = await fetch(url, { signal: this.abortController.signal });
            if (!response.ok || !response.body) {
                this.buildLog += `\n❌ ${title} request failed (${response.status})\n`;
                await this.service.render();
                this.abortController = null;
                return false;
            }
            const reader = response.body!.getReader();
            const decoder = new TextDecoder();
            let buffer = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n');
                buffer = lines.pop() || '';

                for (const line of lines) {
                    if (!line.startsWith('data: ')) continue;
                    try {
                        const event = JSON.parse(line.substring(6));
                        if (event.type === 'step') {
                            this.buildLog += `\n${event.message}\n`;
                        } else if (event.type === 'log') {
                            this.buildLog += event.message + '\n';
                        } else if (event.type === 'error') {
                            this.buildLog += `\n❌ ${event.message}\n`;
                        } else if (event.type === 'done') {
                            this.buildLog += `\n✅ ${event.message}\n`;
                            success = true;
                        }
                        this.scrollLogToBottom();
                        await this.service.render();
                    } catch (e) { }
                }
            }
            // Process remaining buffer after stream ends
            if (buffer.startsWith('data: ')) {
                try {
                    const event = JSON.parse(buffer.substring(6));
                    if (event.type === 'done') {
                        this.buildLog += `\n✅ ${event.message}\n`;
                        success = true;
                    } else if (event.type === 'error') {
                        this.buildLog += `\n❌ ${event.message}\n`;
                    }
                    await this.service.render();
                } catch (e) { }
            }
        } catch (e: any) {
            if (e.name === 'AbortError') {
                this.buildLog += '\n⚠️ Cancelled by user\n';
            } else {
                this.buildLog += `\n❌ Error: ${e}\n`;
            }
            await this.service.render();
        }

        this.abortController = null;
        return success;
    }

    private scrollLogToBottom() {
        setTimeout(() => {
            if (this.logContainer?.nativeElement) {
                this.logContainer.nativeElement.scrollTop = this.logContainer.nativeElement.scrollHeight;
            }
        }, 0);
    }

    public async dockerBuild() {
        if (this.building) return;

        // Save current file first
        if (this.selectedFile && this.editor) {
            await this.saveFile();
        }

        this.building = true;
        this.data.status = 'building';
        await this.service.render();

        const url = `/wiz/api/page.admin.images.item/build?id=${encodeURIComponent(this.id)}`;
        const success = await this.runSSE(url, 'Build');

        this.building = false;
        // Reload from server to get actual DB status
        const { code, data } = await wiz.call("get", { id: this.id });
        if (code === 200) {
            this.data = data;
        } else {
            this.data.status = success ? 'ready' : 'error';
        }
        await this.service.render();
    }

    public async dockerPush() {
        if (this.pushing) return;

        this.pushing = true;
        this.data.status = 'pushing';
        await this.service.render();

        const url = `/wiz/api/page.admin.images.item/push?id=${encodeURIComponent(this.id)}`;
        const success = await this.runSSE(url, 'Push');

        this.pushing = false;
        // Reload from server to get actual DB status
        const { code, data } = await wiz.call("get", { id: this.id });
        if (code === 200) {
            this.data = data;
        } else {
            this.data.status = success ? 'ready' : 'error';
        }
        await this.service.render();
    }

    public async cancelBuild() {
        this.buildLog += '\nCancelling...\n';
        await this.service.render();
        // Abort the SSE fetch
        if (this.abortController) {
            this.abortController.abort();
        }
        // Kill server-side process
        try {
            await wiz.call("cancel", { id: this.id });
        } catch (e) { }
    }

    public async closeLogModal() {
        if (this.building || this.pushing) return; // Don't close while running
        this.showLogModal = false;
        await this.service.render();
    }

    public statusColor(status: string) {
        const map: any = {
            'draft': 'bg-gray-100 text-gray-700',
            'building': 'bg-yellow-100 text-yellow-700',
            'pushing': 'bg-blue-100 text-blue-700',
            'ready': 'bg-green-100 text-green-700',
            'error': 'bg-red-100 text-red-700'
        };
        return map[status] || 'bg-gray-100 text-gray-700';
    }

    // ──────────── Git operations ────────────

    public async toggleGitPanel() {
        this.activeToolPanel = this.activeToolPanel === 'git' ? '' : 'git';
        this.showGitPanel = this.activeToolPanel === 'git';
        this.showSettingsModal = false;
        this.stopAgentPolling();
        if (this.showGitPanel) {
            await this.loadGitStatus();
            await this.loadGitLog();
        }
        await this.service.render();
    }

    public async loadGitStatus() {
        const { code, data } = await wiz.call("git_status", { id: this.id });
        if (code === 200) {
            this.gitStatus = data;
        }
        await this.service.render();
    }

    public async loadGitLog() {
        const { code, data } = await wiz.call("git_log", { id: this.id });
        if (code === 200) {
            this.gitLog = data;
        }
        await this.service.render();
    }

    public async gitInit() {
        this.gitLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call("git_init", { id: this.id });
        if (code === 200) {
            await this.service.modal.success("Git repository initialized");
        } else {
            await this.service.modal.error(data?.message || "Init failed");
        }
        await this.loadGitStatus();
        this.gitLoading = false;
        await this.service.render();
    }

    public async gitClone() {
        if (!this.data.git_url) {
            await this.service.modal.error("Git URL not configured. Set it in Settings.");
            return;
        }
        this.gitLoading = true;
        this.buildLogTitle = 'Git Clone Log';
        this.buildLog = 'Cloning repository...\n';
        this.showLogModal = true;
        await this.service.render();
        const { code, data } = await wiz.call("git_clone", { id: this.id });
        if (code === 200) {
            this.buildLog += data.message || 'Clone completed';
            this.buildLog += '\n✅ Clone completed successfully!';
            await this.refreshTree();
            await this.loadGitStatus();
            await this.loadGitLog();
        } else {
            this.buildLog += '\n❌ Clone failed: ' + (data?.message || 'Unknown error');
        }
        this.gitLoading = false;
        await this.service.render();
    }

    public async gitCommit() {
        if (!this.gitCommitMessage.trim()) {
            await this.service.modal.error("Commit message is required");
            return;
        }
        this.gitLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call("git_commit", { id: this.id, message: this.gitCommitMessage });
        if (code === 200) {
            await this.service.modal.success("Changes committed");
            this.gitCommitMessage = '';
            await this.loadGitStatus();
            await this.loadGitLog();
        } else {
            await this.service.modal.error(data?.message || "Commit failed");
        }
        this.gitLoading = false;
        await this.service.render();
    }

    public async gitPush() {
        if (!this.data.git_url) {
            await this.service.modal.error("Git URL not configured");
            return;
        }
        this.gitLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call("git_push", { id: this.id });
        if (code === 200) {
            await this.service.modal.success("Pushed to remote");
        } else {
            await this.service.modal.error(data?.message || "Push failed");
        }
        this.gitLoading = false;
        await this.service.render();
    }

    public async gitPull() {
        if (!this.data.git_url) {
            await this.service.modal.error("Git URL not configured");
            return;
        }
        this.gitLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call("git_pull", { id: this.id });
        if (code === 200) {
            await this.service.modal.success("Pulled from remote");
            await this.refreshTree();
            await this.loadGitStatus();
            await this.loadGitLog();
            // Reload current file if open
            if (this.selectedFile) {
                const res = await wiz.call("read_file", { id: this.id, path: this.selectedFile });
                if (res.code === 200) {
                    this.selectedFileContent = res.data.content;
                    this.updateMonacoContent();
                }
            }
        } else {
            await this.service.modal.error(data?.message || "Pull failed");
        }
        this.gitLoading = false;
        await this.service.render();
    }

    public gitChangedFiles() {
        if (!this.gitStatus.status) return [];
        return this.gitStatus.status.trim().split('\n').filter((l: string) => l.trim());
    }

    // ──────────── Codex agent sessions ────────────

    public async toggleAgentPanel() {
        this.activeToolPanel = this.activeToolPanel === 'agent' ? '' : 'agent';
        this.showGitPanel = this.activeToolPanel === 'git';
        this.showSettingsModal = false;
        if (this.activeToolPanel === 'agent') {
            this.agentView = 'history';
            await this.loadAgentSessions();
        } else {
            this.stopAgentPolling();
        }
        await this.service.render();
    }

    public async loadAgentSessions() {
        this.agentLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call("agent_sessions", { id: this.id });
        if (code === 200) {
            this.agentSessions = data || [];
        }
        this.agentLoading = false;
        await this.service.render();
    }

    public async openNewAgentSession() {
        this.selectedAgentSession = null;
        this.agentPrompt = '';
        this.agentView = 'new';
        this.expandedAgentPromptIndex = -1;
        this.stopAgentPolling();
        await this.service.render();
    }

    public async openAgentSession(session: any) {
        this.selectedAgentSession = session;
        this.agentPrompt = '';
        this.agentView = 'detail';
        this.expandedAgentPromptIndex = -1;
        await this.loadAgentSession(session.id);
        if (this.isAgentRunning(this.selectedAgentSession)) this.startAgentPolling();
        await this.service.render();
    }

    public async backToAgentHistory() {
        this.agentView = 'history';
        this.selectedAgentSession = null;
        this.agentPrompt = '';
        this.expandedAgentPromptIndex = -1;
        this.stopAgentPolling();
        await this.loadAgentSessions();
    }

    public async loadAgentSession(sessionId: string) {
        const { code, data } = await wiz.call("agent_session", { id: this.id, session_id: sessionId });
        if (code === 200) {
            this.selectedAgentSession = data;
        }
        await this.service.render();
    }

    public async startAgentSession() {
        const prompt = (this.agentPrompt || '').trim();
        if (!prompt) {
            await this.service.modal.error("Prompt is required");
            return;
        }

        const params: any = { id: this.id, prompt };
        if (this.selectedAgentSession?.id) {
            params.session_id = this.selectedAgentSession.id;
        }

        this.agentLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call("agent_start", params);
        this.agentLoading = false;
        if (code === 200) {
            this.selectedAgentSession = data;
            this.agentPrompt = '';
            this.agentView = 'detail';
            this.expandedAgentPromptIndex = -1;
            this.startAgentPolling();
        } else {
            await this.service.modal.error(data?.message || "Agent failed to start");
        }
        await this.service.render();
    }

    public async cancelAgentSession() {
        if (!this.selectedAgentSession?.id) return;
        await wiz.call("agent_cancel", { id: this.id, session_id: this.selectedAgentSession.id });
        await this.loadAgentSession(this.selectedAgentSession.id);
        this.stopAgentPolling();
    }

    public async deleteAgentSession(session: any, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!session?.id) return;

        const message = this.isAgentRunning(session)
            ? "Running session will be cancelled and deleted. Delete this history?"
            : "Delete this agent history?";
        if (!await this.service.modal.error(message, "Cancel", "Delete")) return;

        this.agentLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call("agent_delete", { id: this.id, session_id: session.id });
        this.agentLoading = false;

        if (code === 200) {
            if (this.selectedAgentSession?.id === session.id) {
                this.selectedAgentSession = null;
                this.agentPrompt = '';
                this.agentView = 'history';
                this.expandedAgentPromptIndex = -1;
                this.stopAgentPolling();
            }
            await this.loadAgentSessions();
            return;
        }

        await this.service.modal.error(data?.message || "Delete failed");
        await this.service.render();
    }

    public isAgentRunning(session: any) {
        return session?.status === 'running' || session?.status === 'queued';
    }

    public agentStatusColor(status: string) {
        const map: any = {
            'queued': 'bg-gray-100 text-gray-700',
            'running': 'bg-amber-100 text-amber-800',
            'completed': 'bg-emerald-100 text-emerald-800',
            'error': 'bg-red-100 text-red-700'
        };
        return map[status] || 'bg-gray-100 text-gray-700';
    }

    public agentTurns(session: any) {
        if (!session) return [];
        const parsedTurns = this.parseAgentTurnPayload(session.prompt);
        if (parsedTurns.length > 0) {
            const lastTurn = parsedTurns[parsedTurns.length - 1];
            if (session.response && !lastTurn.response && !this.isAgentRunning(session)) {
                lastTurn.response = session.response;
            }
            if (session.error && !lastTurn.error && !this.isAgentRunning(session)) {
                lastTurn.error = session.error;
            }
            return parsedTurns;
        }

        const prompts = this.splitAgentTurnText(session.prompt);
        const responses = this.splitAgentTurnText(session.response);
        const errors = this.splitAgentTurnText(session.error);
        const count = Math.max(prompts.length, responses.length, errors.length);
        const turns = [];
        for (let i = 0; i < count; i++) {
            turns.push({
                prompt: prompts[i] || '',
                response: responses[i] || '',
                error: errors[i] || ''
            });
        }
        return turns;
    }

    private parseAgentTurnPayload(value: string) {
        try {
            const parsed = JSON.parse(value || '');
            if (!Array.isArray(parsed)) return [];
            return parsed
                .filter((item) => item && typeof item === 'object')
                .map((item) => ({
                    prompt: String(item.prompt || ''),
                    response: String(item.response || ''),
                    error: String(item.error || '')
                }))
                .filter((item) => item.prompt || item.response || item.error);
        } catch (e) {
            return [];
        }
    }

    private splitAgentTurnText(value: string) {
        return String(value || '')
            .split(this.agentTurnSeparator)
            .map((item) => item.trim())
            .filter((item) => item.length > 0);
    }

    public isAgentPromptLong(value: string) {
        const text = value || '';
        return text.length > 520 || text.split('\n').length > 8;
    }

    public isAgentPromptExpanded(index: number) {
        return this.expandedAgentPromptIndex === index;
    }

    public visibleAgentPrompt(value: string, index: number) {
        const text = value || '';
        if (this.isAgentPromptExpanded(index) || !this.isAgentPromptLong(text)) return text;

        const lines = text.split('\n');
        let preview = lines.length > 8 ? lines.slice(0, 8).join('\n') : text;
        if (preview.length > 520) preview = preview.slice(0, 520);
        return preview.replace(/\s+$/g, '') + '\n...';
    }

    public async toggleAgentPromptExpanded(index: number, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.expandedAgentPromptIndex = this.isAgentPromptExpanded(index) ? -1 : index;
        await this.service.render();
    }

    public renderAgentMarkdown(value: string) {
        const lines = (value || '').replace(/\r\n/g, '\n').split('\n');
        const html: string[] = [];
        let paragraph: string[] = [];
        let listType = '';
        let inCode = false;
        let codeLang = '';
        let codeLines: string[] = [];

        const flushParagraph = () => {
            if (paragraph.length === 0) return;
            html.push(`<p>${this.renderInlineMarkdown(paragraph.join(' '))}</p>`);
            paragraph = [];
        };

        const closeList = () => {
            if (!listType) return;
            html.push(`</${listType}>`);
            listType = '';
        };

        const openList = (type: string) => {
            if (listType === type) return;
            closeList();
            html.push(`<${type}>`);
            listType = type;
        };

        for (const rawLine of lines) {
            const fence = rawLine.match(/^```([A-Za-z0-9_-]+)?\s*$/);
            if (inCode) {
                if (fence) {
                    const langClass = codeLang ? ` class="language-${this.escapeAttribute(codeLang)}"` : '';
                    html.push(`<pre><code${langClass}>${this.escapeHtml(codeLines.join('\n'))}</code></pre>`);
                    inCode = false;
                    codeLang = '';
                    codeLines = [];
                } else {
                    codeLines.push(rawLine);
                }
                continue;
            }

            if (fence) {
                flushParagraph();
                closeList();
                inCode = true;
                codeLang = fence[1] || '';
                codeLines = [];
                continue;
            }

            const line = rawLine.trim();
            if (!line) {
                flushParagraph();
                closeList();
                continue;
            }

            const heading = line.match(/^(#{1,6})\s+(.+)$/);
            if (heading) {
                flushParagraph();
                closeList();
                const level = heading[1].length;
                html.push(`<h${level}>${this.renderInlineMarkdown(heading[2])}</h${level}>`);
                continue;
            }

            const unordered = line.match(/^[-*]\s+(.+)$/);
            if (unordered) {
                flushParagraph();
                openList('ul');
                html.push(`<li>${this.renderInlineMarkdown(unordered[1])}</li>`);
                continue;
            }

            const ordered = line.match(/^\d+\.\s+(.+)$/);
            if (ordered) {
                flushParagraph();
                openList('ol');
                html.push(`<li>${this.renderInlineMarkdown(ordered[1])}</li>`);
                continue;
            }

            const quote = line.match(/^>\s+(.+)$/);
            if (quote) {
                flushParagraph();
                closeList();
                html.push(`<blockquote>${this.renderInlineMarkdown(quote[1])}</blockquote>`);
                continue;
            }

            paragraph.push(line);
        }

        if (inCode) {
            const langClass = codeLang ? ` class="language-${this.escapeAttribute(codeLang)}"` : '';
            html.push(`<pre><code${langClass}>${this.escapeHtml(codeLines.join('\n'))}</code></pre>`);
        }
        flushParagraph();
        closeList();

        return html.join('');
    }

    private renderInlineMarkdown(value: string) {
        let html = this.escapeHtml(value);
        html = html.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+|\/[^\s)]*)\)/g, '<a href="$2" target="_blank" rel="noreferrer">$1</a>');
        html = html.replace(/`([^`]+)`/g, '<code>$1</code>');
        html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
        html = html.replace(/\*([^*]+)\*/g, '<em>$1</em>');
        return html;
    }

    private escapeHtml(value: string) {
        return String(value || '').replace(/[&<>"']/g, (char) => {
            const map: any = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
            return map[char];
        });
    }

    private escapeAttribute(value: string) {
        return this.escapeHtml(value).replace(/`/g, '&#96;');
    }

    private async refreshAgentFileViewer() {
        await this.refreshTree();
        if (!this.selectedFile) {
            await this.service.render();
            return;
        }

        const { code, data } = await wiz.call("read_file", { id: this.id, path: this.selectedFile });
        if (code === 200) {
            this.selectedFileContent = data.content;
        } else {
            this.selectedFileContent = '';
        }
        this.updateMonacoContent();
        await this.service.render();
    }

    private startAgentPolling() {
        this.stopAgentPolling();
        if (!this.selectedAgentSession?.id) return;
        this.agentPollTimer = setInterval(async () => {
            if (!this.selectedAgentSession?.id) return;
            await this.loadAgentSession(this.selectedAgentSession.id);
            if (!this.isAgentRunning(this.selectedAgentSession)) {
                await this.refreshAgentFileViewer();
                this.stopAgentPolling();
                await this.loadAgentSessions();
            }
        }, 2000);
    }

    private stopAgentPolling() {
        if (this.agentPollTimer) {
            clearInterval(this.agentPollTimer);
            this.agentPollTimer = null;
        }
    }
}

export default PageAdminImagesItemComponent;